import { z } from 'zod';

export const loginSchema = z.object({
    email: z
        .string()
        .min(1, { message: 'Email is required' })
        .email({ message: 'Invalid email address' }),
    password: z
        .string()
        .min(1, { message: 'Password is required' })
        .min(8, { message: 'Password must be at least 8 characters' }),
});

export const TwoFASchema = z.object({
    code: z.string().min(6, { message: 'Invalid code' }).max(6, { message: 'Invalid code' })
});

export type LoginFormValues = z.infer<typeof loginSchema>;
export type TwoFAFormValues = z.infer<typeof TwoFASchema>;